<template>
    <div>
        <el-tabs type="border-card">
            <el-tab-pane label="节点设置">
                <el-form :model="approverForm" label-width="150px" label-position="top">
                    <input type="hidden" v-model="approverForm.id"/>
                    <el-form-item label="节点名称">
                        <el-input v-model="approverForm.name"></el-input>
                    </el-form-item>
                    <input type="hidden" v-model="approverForm.approverType"/>
                    <div v-if="!approverForm.isStartNode && !approverForm.isEndNode">
                    <el-form-item label="选择审批人">
                        <el-input v-model="approveType[approverForm.approverType]" @focus="checkApprover"></el-input>
                    </el-form-item>
                    <el-form-item label="选择了多个审批人时">
                        <template>
                            <el-select class="mostApproverSelect" v-model="approverForm.mostApproverType"
                                       placeholder="请选择">
                                <el-option v-for="item in mostApproverOptions" :key="item.value" :label="item.label"
                                           :value="item.value">
                                    <span style="display: block;">{{item.label}}</span>
                                    <span>{{item.explain}}</span>
                                </el-option>
                            </el-select>
                        </template>
                    </el-form-item>
                    <el-form-item label="可编辑单元格">
                        <label slot="label">
                            <span class="form-title">可编辑单元格</span>
                            <el-popover placement="top-start" title="" width="300" trigger="hover"
                                        content="可设置该节点的审批人员对表单内容编辑权限">
                                <i class="el-icon-question" slot="reference"></i>
                            </el-popover>
                        </label>
                        <el-input v-model="editableFieldNames" @focus="checkCells('edit')"></el-input>
                    </el-form-item>
                    <el-form-item label="可隐藏单元格">
                        <label slot="label">
                            <span class="form-title">可隐藏单元格</span>
                            <el-popover placement="top-start" title="" width="300" trigger="hover"
                                        content="可设置该节点的审批人员对表单内容查看权限">
                                <i class="el-icon-question" slot="reference"></i>
                            </el-popover>
                        </label>
                        <el-input v-model="invisibleFieldNames" @focus="checkCells('visible')"></el-input>
                    </el-form-item>
                    </div>
                    <el-form-item label="抄送方式">
                        <el-input v-model="copyType[approverForm.copyType]" @focus="checkCopyPerson"></el-input>
                    </el-form-item>
                    <div v-if="!approverForm.isStartNode && !approverForm.isEndNode">
                    <el-form-item label="退回方式">
                        <label slot="label">
                            <span class="form-title">退回方式</span>
                            <el-popover placement="top-start" title="" width="300" trigger="hover"
                                        content="审批人驳回审批时，可将审批退回到申请人或指定节点">
                                <i class="el-icon-question" slot="reference"></i>
                            </el-popover>
                        </label>
                        <template>
                            <el-select v-model="returnType" placeholder="请选择" @change="returnTypeChange">
                                <el-option v-for="item in optionReturn" :key="item.value" :label="item.label"
                                           :value="item.value">
                                </el-option>
                            </el-select>
                        </template>
                    </el-form-item>
                    <el-form-item v-if="returnType == 'anyone'">
                        <template>
                            <el-select v-model="approverForm.returnNodeId" placeholder="请选择" @change="handlerChange">
                                <el-option v-for="item in getAllNodeId" :key="item.id" :label="item.name"
                                           :value="item.id">
                                </el-option>
                            </el-select>
                        </template>
                    </el-form-item>
                    <el-form-item label="">
                        <template>
                            <el-checkbox v-model="approverForm.checked">没有审核人时自动提交至下个节点</el-checkbox>
                        </template>
                    </el-form-item>
                    </div>
                </el-form>
            </el-tab-pane>
        </el-tabs>
        <div v-if="dialogApproverVisible">
            <el-dialog title="选择审批人" :visible.sync="dialogApproverVisible" :append-to-body="true" width="800px">
                <select-approver @onchangeapprover="onChangeApprover" :default-upquery="approverForm.upQuery"
                                 :default-checkedformfieldids="approverForm.approverFormFieldIds"
                                 :default-title="approverForm.approverText"
                                 :default-type="approverForm.approverType"
                                 :default-checkeduserids="approverForm.approverIds"
                                 :default-checkedroleids="approverForm.approverRoleIds"
                                 :default-checkeddepartmentids="approverForm.approverDepartmentIds"></select-approver>
            </el-dialog>
        </div>
        <div v-if="dialogCopyVisible">
            <el-dialog title="选择抄送人" :visible.sync="dialogCopyVisible" :append-to-body="true" width="800px">
                <select-approver @onchangeapprover="onChangeCopyperson"
                                 :default-checkedformfieldids="approverForm.copyFormFieldIds"
                                 :default-title="approverForm.copyText" :default-type="approverForm.copyType"
                                 :default-checkeduserids="approverForm.copyIds"
                                 :default-checkedroleids="approverForm.copyRoleIds" :card-type="2"
                                 :default-checkeddepartmentids="approverForm.copyDepartmentIds"></select-approver>
            </el-dialog>
        </div>
        <el-dialog title="选择" :visible.sync="dialogCellsVisible" :append-to-body="true" width="800px">
            <checkbox-list :data-source="txtTableFieldOptions" :checked-items="checkedFields"
                           @onchecked="handleClickChecked"></checkbox-list>
            <div style="text-align: right;">
                <el-button size="small" @click="dialogCellsVisible = false">取消</el-button>
                <el-button type="primary" size="small" @click="handleClickCells">确定</el-button>
            </div>
        </el-dialog>
        <div class="dialog-footer">
<!--                <el-button @click="visible = false" size="mini">取 消</el-button>-->
<!--                <el-button type="primary" size="mini">确 定</el-button>-->
        </div>
    </div>
</template>

<script>
    import SelectApprover from "./SelectApprover";
    import CheckboxList from "./CheckboxList";
    import workflowService from "../service/flowChart/workflowService";

    export default {
        components: {
            SelectApprover,
            CheckboxList,
        },
        props: {
            visible: {
                type: Boolean,
                default: false,
            },
            approverForm: {
                type: Object,
                default: () => {

                }
            },
            nodes: {
                type: Array,
                default: () => [
                    {id: 1, x: 140, y: 270, name: '开始', type: 'start'},
                    {id: 2, x: 540, y: 270, name: '结束', type: 'end'},
                ],
            },
            start: {
                type: Object,
                default: () => {
                }
            }
        },
        data() {
            return {
                states: ["zsl", "joyce"],
                options: [],
                list: [],
                loading: false,
                dialogApproverVisible: false,
                dialogCopyVisible: false,
                dialogCellsVisible: false,
                approveType: {
                    "1": "员工审核",
                    "2": "岗位审核",
                    "26": "提交人",
                    "3": "本人上级审核",
                    "4": "部门主管审核",
                    "8": "部门岗位审核",
                    "27": "表单员工",
                    "35": "自由选择人员",
                },
                copyType: {
                    "1": "员工审核",
                    "2": "岗位审核",
                    "3": "本人上级审核",
                    "4": "部门主管审核",
                    "8": "部门岗位审核",
                    "27": "表单员工",
                },
                optionReturn: [{
                    value: 'start',
                    label: '退回到开始节点'
                }, {
                    value: 'anyone',
                    label: '退回到指定节点'
                }],
                isClickEditCells: false,
                returnType: '',
                txtTableFieldOptions: [],
                checkedFields: [],
                txtEditableFields: this.approverForm.txtEditableFields || [],
                txtInvisibleFields: this.approverForm.txtInvisibleFields || [],
                editableFieldNames: '',
                invisibleFieldNames: '',
                getAllNodeId: ''
            }
        },
        computed: {
            mostApproverOptions: function () {
                let mostApproverArr = [];
                mostApproverArr = [{
                    value: '2',
                    label: '会签',
                    explain: '多个审批人必须全部进行审批才可进入下一节点'
                }, {
                    value: '3',
                    label: '依次审批',
                    explain: '多个审批人按照选择顺序依次审批后可进入下一节点'
                }]

                return mostApproverArr
            },

        },
        watch: {
            returnType(newVal, oldVal) {
                this.returnType = newVal
            },
            approverForm: {
                immediate: true,
                deep: true,
                handler() {

                },
            },
        },
        async mounted() {
            let TableFieldResp = await workflowService.getFormFieldsOptions(this.$route.query.id || 1, "", "");
            if (TableFieldResp.data.Status === "1") {
                this.txtTableFieldOptions = TableFieldResp.data.Data;
            }
            if (!this.approverForm.returnNodeId || parseInt(this.approverForm.returnNodeId) <= 0) {
                this.returnType = 'start'
                this.approverForm.returnNodeId = '';
            } else {
                this.returnType = 'anyone'
            }
            this.list = this.states.map(item => {
                return {
                    value: item,
                    label: item
                };
            });
            this.getEditableFieldNames();
            this.getInvisibleFieldNames();
            this.getAllNodeIds();
        },
        methods: {
            handlerChange: function() {
                this.$forceUpdate()
            },
            getAllNodeIds: function () {
                this.getAllNodeId = this.nodes.map(item => {
                    return {
                        id: item.id,
                        name: item.name
                    };
                });
            },
            getInvisibleFieldNames: function () {
                let newCheckedOptions = [];
                let visibleIds = this.approverForm.txtInvisibleFields || [];
                this.txtTableFieldOptions.forEach((obj, i) => {
                    visibleIds.forEach((uuid, j) => {
                        if (obj.uuid == uuid) {
                            newCheckedOptions.push(obj.name)
                        }
                    })
                })
                this.invisibleFieldNames = newCheckedOptions.join(",");
            },
            getEditableFieldNames: function () {
                let newCheckedOptions = [];
                let editIds = this.approverForm.txtEditableFields || [];
                this.txtTableFieldOptions.forEach((obj, i) => {
                    editIds.forEach((uuid, j) => {
                        if (obj.uuid == uuid) {
                            newCheckedOptions.push(obj.name)
                        }
                    })
                })
                this.editableFieldNames = newCheckedOptions.join(",");
            },
            checkCells(str) {
                if (str == 'edit') {
                    this.isClickEditCells = true;
                    this.checkedFields = this.approverForm.txtEditableFields || [];
                } else {
                    this.isClickEditCells = false;
                    this.checkedFields = this.approverForm.txtInvisibleFields || [];
                }
                this.dialogCellsVisible = true;
            },
            handleClickChecked(data) {
                if (this.isClickEditCells) {
                    this.txtEditableFields = data.checkedOptions.map(item => item.uuid);
                } else {
                    this.txtInvisibleFields = data.checkedOptions.map(item => item.uuid);
                }

            },
            handleClickCells() {
                this.approverForm.txtEditableFields = this.txtEditableFields;
                this.approverForm.txtInvisibleFields = this.txtInvisibleFields;
                this.getEditableFieldNames();
                this.getInvisibleFieldNames();
                this.dialogCellsVisible = false;
            },
            returnTypeChange(item) {
                if (item == 'start') {
                    this.approverForm.returnNodeId = '';
                }
            },
            remoteMethod(query) {
                if (query !== '') {
                    this.loading = true;
                    setTimeout(() => {
                        this.loading = false;
                        this.options = this.list.filter(item => {
                            return item.label.toLowerCase()
                                .indexOf(query.toLowerCase()) > -1;
                        });
                    }, 200);
                } else {
                    this.options = [];
                }
            },
            checkApprover() {
                this.dialogApproverVisible = true
            },
            checkCopyPerson() {
                this.dialogCopyVisible = true;
            },
            onChangeApprover(data) {
                this.approverForm.approverDepartmentIds = data.checkedDepartments.map(item => item.uuid);
                this.approverForm.approverRoleIds = data.checkedRoles.map(item => item.uuid);
                this.approverForm.approverIds = data.checkedUsers.map(item => item.uuid);
                this.approverForm.approverType = data.type;
                this.approverForm.approverText = data.title;
                this.approverForm.approverFormFieldIds = data.checkedFields.map(item => item.uuid);
                this.approverForm.upQuery = data.upQuery;
                this.dialogApproverVisible = false;

            },
            onChangeCopyperson(data) {
                this.approverForm.copyDepartmentIds = data.checkedDepartments.map(item => item.uuid);
                this.approverForm.copyRoleIds = data.checkedRoles.map(item => item.uuid);
                this.approverForm.copyIds = data.checkedUsers.map(item => item.uuid);
                this.approverForm.copyType = data.type;
                this.approverForm.copyText = data.title;
                this.approverForm.copyFormFieldIds = data.checkedFields.map(item => item.uuid);
                this.dialogCopyVisible = false;
            },

        },

    }
</script>
<style>
    .el-drawer {
        overflow-y: auto;
    }
    .el-select {
        width: 100%;
    }
    .el-drawer__header {
        height: 0 !important;
        margin: 0 !important;
        padding: 0 !important;
        overflow: hidden;
    }
    .dialog-footer {
        text-align: right;
        padding-right: 20px;
        margin-top: 20px;
    }
    .el-tabs--border-card {
        border:none;
        box-shadow: none;
    }
    .el-icon-question {
        font-size: 20px;
    }

    .form-title {
        margin-right: 5px;
    }

    .el-form-item {
        margin-bottom: 5px;
    }

    .el-form--label-top .el-form-item__label {
        padding: 0;
        font-size: 16px;
        margin-top: 8px;
    }

    .el-select-dropdown__item {
        height: auto !important;
        line-height: 22px !important;
        padding: 6px 20px !important;
    }

    .el-select-dropdown__item span:nth-child(2) {
        font-size: 12px;
        color: #a09e9e;
    }
</style>
